import Card from './Card';
import { ReturnTranslatedText } from '@wajeez-web/core/localization';
export interface StatsDisplayProps {
  icon: React.ReactNode;
  label: string;
  value: string | number;
  loading: boolean;
}

const StatDisplay = ({ icon, label, value, loading }: StatsDisplayProps) => {
  return (
    <Card>
      <div className="flex flex-row items-center space-s-2">
        {icon}
        <div className="space-y-1">
          <div className="text-sm text-gray-500">
            {' '}
            <ReturnTranslatedText text={`charts.title.${label}`} />
          </div>
          {loading ? (
            <div className="loading  flex justify-center items-center align-middle">
              <div className="spinner-border text-primary" role="status">
                <span className="">
                  <ReturnTranslatedText text="general.Loading" />
                </span>
              </div>
            </div>
          ) : (
            <div className="text-xl font-bold">{value}</div>
          )}
        </div>
      </div>
    </Card>
  );
};

export default StatDisplay;
